// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"320":"a0eb1640","725":"cbea3b7c","787":"9bd45092"}[chunkId] + ".chunk.css";
};